import {
    DARK_GREY_COLOR,
    STATUS_CRITICAL_COLOR,
    STATUS_MAJOR_COLOR,
    STATUS_MINOR_COLOR
} from "@nms-ng2/app/shared/constants/colors";
import { AlarmDiagnosticData, AlarmSeverity } from "../../dwdm-circuit.model";

/** Interface que representa os valores da tabela de detalhes do alarme */
export interface AlarmDetailsData {
    alarmDiagnosticData:Array<AlarmDiagnosticData>
}

/** Tipo a ser utilizado no status do alarme */
export const ALARM_SEVERITY = {
    [AlarmSeverity.MINOR]: {
        translationKey: "status.minorFault",
        bgColor: STATUS_MINOR_COLOR,
        color: DARK_GREY_COLOR
    },
    [AlarmSeverity.MAJOR]: {
        translationKey: "status.majorFault",
        bgColor: STATUS_MAJOR_COLOR,
        color: DARK_GREY_COLOR
    },
    [AlarmSeverity.CRITICAL]: {
        translationKey: "status.criticalFault",
        bgColor: STATUS_CRITICAL_COLOR,
        color: DARK_GREY_COLOR
    }
}
